// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"978":"84a49c036a4ca7d6","1124":"5d7bde156ccdef4b","5046":"50cb094ad23a3485","6187":"e3d831a86261ef6b","9861":"299ecddc6b772f8d"}[chunkId] + ".css";
};